mutation TravelPlanGenerateDocument($travelPlanId: UUID!) {
  travelPlanGenerateDocument(input: { travelPlanId: $travelPlanId }) {
    travelPlanId
    isGenerating
  }
}
